import React, { useState } from "react";
import { Modal, Button, Alert, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "../../context/AxiosInstance";

const VerrouillageSalaireModal = ({ 
  show, 
  onHide, 
  employe, 
  mois, 
  annee, 
  idContrat, 
  onVerrouillageSuccess 
}) => {
  const [loading, setLoading] = useState(false);

  const handleVerrouiller = async () => {
    setLoading(true);
    try {
      const response = await axios.post("/salaires/verrouiller/", null, {
        params: {
          id_contrat: idContrat,
          mois: mois,
          annee: annee
        }
      });

      if (response.data.success) {
        toast.success(response.data.message);
        onVerrouillageSuccess();
        onHide();
      }
    } catch (error) {
      const message = error.response?.data?.detail || "Erreur lors du verrouillage";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>
          <i className="fas fa-lock me-2"></i>
          Verrouillage des Salaires
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Alert variant="warning" className="mb-4">
          <Alert.Heading>
            <i className="fas fa-exclamation-triangle me-2"></i>
            Attention - Action Irréversible
          </Alert.Heading>
          <p>
            Vous êtes sur le point de <strong>verrouiller définitivement</strong> les salaires de :
          </p>
          <ul>
            <li><strong>Employé :</strong> {employe?.nom} {employe?.prenom}</li>
            <li><strong>Période :</strong> {mois} {annee}</li>
          </ul>
        </Alert>

        <Alert variant="danger">
          <h6>⚠️ Conséquences du verrouillage :</h6>
          <ul className="mb-0">
            <li>Les salaires ne pourront plus être <strong>modifiés</strong> ni <strong>supprimés</strong></li>
            <li>Les données seront transférées dans une table sécurisée</li>
            <li>L'impression des bulletins se fera à partir des données verrouillées</li>
            <li>Cette action est <strong>irréversible</strong></li>
          </ul>
        </Alert>

        <Alert variant="info">
          <h6>✅ Avantages du verrouillage :</h6>
          <ul className="mb-0">
            <li>Intégrité des données garantie</li>
            <li>Impression plus rapide des bulletins</li>
            <li>Traçabilité complète des modifications</li>
            <li>Conformité réglementaire</li>
          </ul>
        </Alert>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          <i className="fas fa-times me-2"></i>
          Annuler
        </Button>
        <Button 
          variant="warning" 
          onClick={handleVerrouiller} 
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Verrouillage en cours...
            </>
          ) : (
            <>
              <i className="fas fa-lock me-2"></i>
              Verrouiller les Salaires
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VerrouillageSalaireModal;
